import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import '../../styles/taskManagement.css';
import taskService from '../../services/taskService';

const TaskUpdateForm = ({ task, onSubmitSuccess }) => {
  const { currentUser } = useAuth();
  const [formData, setFormData] = useState({
    status: task?.status || 'pending',
    actual_hours: task?.actual_hours || '',
    completion_note: task?.completion_note || ''
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate actual hours if completing task
    if (formData.status === 'completed' && !formData.actual_hours) {
      setError('Please enter the actual hours spent on this task.');
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      
      // Update task status
      await taskService.updateTaskStatus(task.id, formData);
      
      setLoading(false);
      if (onSubmitSuccess) onSubmitSuccess();
    } catch (err) {
      console.error('Error updating task status:', err);
      setError(err.response?.data?.error || 'Failed to update task status. Please try again.');
      setLoading(false);
    }
  };
  
  return (
    <div className="form-container">
      
      {error && (
        <div className="form-error-message">
          {error}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label" htmlFor="status" data-required="*">
            Status
          </label>
          <select
            id="status"
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="form-select"
            required
          >
            <option value="pending">Pending</option>
            <option value="in_progress">In Progress</option>
            <option value="completed">Completed</option>
          </select>
        </div>
        
        <div className="form-group">
          <label 
            className="form-label" 
            htmlFor="actual_hours" 
            data-required={formData.status === 'completed' ? '*' : undefined}
          >
            Actual Hours Spent
          </label>
          <input
            type="number"
            id="actual_hours"
            name="actual_hours"
            value={formData.actual_hours}
            onChange={handleChange}
            className="form-input"
            min="0.1"
            step="0.1"
            required={formData.status === 'completed'}
          />
          {formData.status === 'completed' && (
            <p className="form-help-text">
              Required when marking a task as completed
            </p>
          )}
        </div>
        
        <div className="form-group">
          <label className="form-label" htmlFor="completion_note">
            Completion Notes
          </label>
          <textarea
            id="completion_note"
            name="completion_note"
            value={formData.completion_note}
            onChange={handleChange}
            className="form-textarea"
            rows="3"
            placeholder="Add any comments about your work on this task..."
          />
        </div>
        
        <div className="form-actions">
          <button
            type="submit"
            className={`btn btn-primary ${loading ? 'btn-loading' : ''}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                <span>Saving...</span>
              </>
            ) : (
              'Update Status'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TaskUpdateForm;
